"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _IconMinus = _interopRequireDefault(require("../../icons/General/IconMinus"));
var _IconPlus = _interopRequireDefault(require("../../icons/General/IconPlus"));
var _IconChevronDown = _interopRequireDefault(require("../../icons/General/IconChevronDown"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const Box = ({
  header,
  collapsable,
  collapsableOpen,
  handleOpenState,
  css,
  type = 'default',
  noshadow,
  background,
  className,
  hideContent,
  children,
  collapseIcon = type === 'default' ? 'plus/minus' : 'chevron',
  ...restProps
}) => {
  const [isOpen, setIsOpen] = (0, _react.useState)(collapsableOpen ? true : false);
  (0, _react.useEffect)(() => {
    if (handleOpenState !== undefined) setIsOpen(handleOpenState);
  }, [handleOpenState]);
  const onCollapseIconClicked = e => {
    setIsOpen(!isOpen);
  };
  const icon = collapseIcon === 'plus/minus' ? isOpen ? (0, _jsxRuntime.jsx)(_IconMinus.default, {
    "aria-hidden": "true"
  }) : (0, _jsxRuntime.jsx)(_IconPlus.default, {
    "aria-hidden": "true"
  }) : (0, _jsxRuntime.jsx)(_IconChevronDown.default, {
    flipVertical: isOpen,
    size: "14px",
    "aria-hidden": "true"
  });
  const headerWrapper = collapsable ? (0, _jsxRuntime.jsx)(_styles.CollapseButton, {
    "aria-label": `Toggle box ${isOpen ? 'closed' : 'open'}`,
    "aria-expanded": isOpen,
    onClick: onCollapseIconClicked,
    nostyle: true,
    children: (0, _jsxRuntime.jsxs)(_styles.HeaderWrapper, {
      border: isOpen,
      children: [header, " ", icon]
    })
  }) : (0, _jsxRuntime.jsx)(_styles.HeaderWrapper, {
    border: true,
    children: header
  });
  return (0, _jsxRuntime.jsxs)("div", {
    role: "group",
    css: theme => [_styles.styles.default(theme), css && css, type === 'mysite' && _styles.styles.mysite(theme), noshadow && _styles.styles.noshadow, background && _styles.styles.background(background)],
    className: className,
    ...restProps,
    children: [header && headerWrapper, (isOpen || !collapsable) && !hideContent && (0, _jsxRuntime.jsx)(_styles.ContentWrapper, {
      children: children
    })]
  });
};
var _default = exports.default = Box;